import React, { useState, useEffect } from 'react';

const Header = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isQRModalOpen, setIsQRModalOpen] = useState(false);

  const slides = [
    {
      image: '/images/slider/slide2.png',
      badge: 'Expertise',
      title: <>Maîtrise <span>Technique</span></>,
      subtitle: 'Serrage et ajustements de précision avec un outillage professionnel certifié.',
      cta: 'Nos services'
    },
    {
      image: '/images/slider/slide3.png',
      badge: 'Fiabilité',
      title: <>Expertise <span>Mécanique</span></>,
      subtitle: 'Entretien complet et réparation toutes marques dans notre garage à Lahage.',
      cta: 'Voir les tarifs'
    },
    {
      image: '/images/slider/slide4.png',
      badge: 'Sécurité',
      title: <>Sécurité <span>Maximale</span></>,
      subtitle: 'Installation de pièces de haute qualité pour une fiabilité sans faille sur la route.',
      cta: 'Demander un devis'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 6000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const handleScroll = (event, targetId) => {
    event.preventDefault();
    const targetElement = document.getElementById(targetId.substring(1));
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="header-slider">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`slide ${index === currentSlide ? 'active' : ''}`}
          style={{ backgroundImage: `linear-gradient(to bottom, rgba(15, 23, 42, 0.4), rgba(15, 23, 42, 0.7)), url(${slide.image})` }}
        >
          <div className="overlay">
            <span className="hero-badge">{slide.badge}</span>
            <h1 className="slide-title">{slide.title}</h1>
            <p className="slide-subtitle">{slide.subtitle}</p>
            <a
              href="#contact"
              className="cta-btn"
              onClick={(e) => handleScroll(e, '#contact')}
            >
              {slide.cta}
            </a>
          </div>
        </div>
      ))}

      <button className="slider-arrow prev" onClick={prevSlide} aria-label="Slide précédente">
        ‹
      </button>
      <button className="slider-arrow next" onClick={nextSlide} aria-label="Slide suivante">
        ›
      </button>

      <div className="slider-dots">
        {slides.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === currentSlide ? 'active' : ''}`}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </div>

      {/* Floating QR Code Support */}
      <div className="qr-floating-support" onClick={() => setIsQRModalOpen(true)} style={{ cursor: 'pointer' }}>
        <div className="qr-box">
          <img 
            src="https://api.qrserver.com/v1/create-qr-code/?size=120x120&data=http://localhost:3004/inscription&color=1e293b&bgcolor=ffffff" 
            alt="QR Code Inscription" 
          />
        </div>
        <div className="qr-text">
          <p>Inscrivez-vous<br/><span>en 1 scan</span></p>
        </div>
      </div>

      {/* QR Code Modal */}
      {isQRModalOpen && (
        <div className="qr-modal-backdrop" onClick={() => setIsQRModalOpen(false)}>
          <div className="qr-modal-content" onClick={e => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setIsQRModalOpen(false)}>&times;</button>
            <div className="modal-inner">
              <span className="modal-badge">Scanner pour s'inscrire</span>
              <h2>Réservez votre place en <span>quelques secondes</span></h2>
              <div className="large-qr-box">
                <img 
                  src="https://api.qrserver.com/v1/create-qr-code/?size=350x350&data=http://localhost:3004/inscription&color=1e293b&bgcolor=ffffff" 
                  alt="Large QR Code" 
                />
              </div>
              <p className="modal-info">Pointez l'appareil photo de votre smartphone vers ce code pour ouvrir la page d'inscription.</p>
              <div className="modal-footer">
                <button onClick={() => setIsQRModalOpen(false)} className="modal-btn-close">Fermer la fenêtre</button>
              </div>
            </div>
          </div>
        </div>
      )}

      <style>{`
        .header-slider {
          height: 100vh;
          position: relative;
          overflow: hidden;
          background: #000;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .slide {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-size: cover;
          background-position: center;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          color: white;
          text-align: center;
          padding: 0 20px;
          opacity: 0;
          transform: scale(1.1);
          transition: opacity 1.5s ease-in-out, transform 8s linear;
          z-index: 0;
        }

        .slide.active {
          opacity: 1;
          transform: scale(1);
          z-index: 1;
        }

        .overlay {
          max-width: 1000px;
          z-index: 2;
          padding: 20px;
        }

        .hero-badge {
          background: #3b82f6;
          color: white;
          padding: 6px 18px;
          border-radius: 50px;
          font-weight: 800;
          font-size: 0.9rem;
          text-transform: uppercase;
          letter-spacing: 2px;
          margin-bottom: 25px;
          display: inline-block;
          animation: slideUp 0.6s ease-out forwards;
        }

        .slide-title {
          font-size: 5.5rem;
          margin-bottom: 25px;
          font-weight: 900;
          text-transform: uppercase;
          line-height: 1.1;
          text-shadow: 0 10px 30px rgba(0,0,0,0.3);
          animation: slideUp 1s ease-out forwards;
        }

        .slide-title span { color: #3b82f6; }

        .slide-subtitle {
          font-size: 1.8rem;
          margin-bottom: 50px;
          max-width: 750px;
          margin-left: auto;
          margin-right: auto;
          font-weight: 300;
          line-height: 1.5;
          opacity: 0.9;
          text-shadow: 0 5px 15px rgba(0,0,0,0.3);
          animation: slideUp 1.2s ease-out forwards;
        }

        @keyframes slideUp {
          from { opacity: 0; transform: translateY(40px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .cta-btn {
          display: inline-block;
          background-color: #3b82f6;
          color: #fff;
          padding: 20px 50px;
          font-size: 1.2rem;
          text-decoration: none;
          border-radius: 12px;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          font-weight: 800;
          letter-spacing: 1px;
          text-transform: uppercase;
          box-shadow: 0 10px 20px rgba(59, 130, 246, 0.3);
        }

        .cta-btn:hover {
          background-color: #2563eb;
          transform: translateY(-5px);
          box-shadow: 0 15px 30px rgba(59, 130, 246, 0.5);
        }

        .slider-arrow {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.1);
          color: white;
          font-size: 3rem;
          padding: 10px 20px;
          cursor: pointer;
          z-index: 10;
          transition: all 0.3s ease;
          border-radius: 50%;
          width: 70px;
          height: 70px;
          display: flex;
          justify-content: center;
          align-items: center;
          backdrop-filter: blur(10px);
        }

        .slider-arrow:hover {
          background: rgba(255, 255, 255, 0.2);
          transform: translateY(-50%) scale(1.1);
        }

        .slider-arrow.prev { left: 50px; }
        .slider-arrow.next { right: 50px; }

        .slider-dots {
          position: absolute;
          bottom: 50px;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          gap: 15px;
          z-index: 10;
        }

        .dot {
          width: 15px;
          height: 4px;
          border-radius: 2px;
          background: rgba(255,255,255,0.3);
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .dot.active {
          background: #3b82f6;
          width: 40px;
          box-shadow: 0 0 15px rgba(59, 130, 246, 0.8);
        }

        /* QR Floating Support Styles */
        .qr-floating-support {
          position: absolute;
          bottom: 40px;
          right: 40px;
          background: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.1);
          padding: 12px;
          border-radius: 20px;
          display: flex;
          align-items: center;
          gap: 15px;
          z-index: 20;
          animation: slideLeft 1s ease-out forwards;
          box-shadow: 0 10px 30px rgba(0,0,0,0.2);
          transition: all 0.3s;
        }

        .qr-floating-support:hover {
          background: rgba(255, 255, 255, 0.1);
          transform: translateY(-5px);
          border-color: #3b82f6;
        }

        @keyframes slideLeft {
          from { opacity: 0; transform: translateX(50px); }
          to { opacity: 1; transform: translateX(0); }
        }

        .qr-box {
          background: white;
          padding: 8px;
          border-radius: 12px;
          width: 80px;
          height: 80px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .qr-box img { width: 100%; height: 100%; }

        .qr-text { color: white; text-align: left; }
        .qr-text p { font-size: 0.95rem; font-weight: 500; line-height: 1.2; margin: 0; }
        .qr-text span { display: inline-block; margin-top: 4px; color: #3b82f6; font-weight: 800; text-transform: uppercase; font-size: 0.8rem; letter-spacing: 0.5px; }

        /* Modal Styles */
        .qr-modal-backdrop {
          position: fixed;
          inset: 0;
          background: rgba(15, 23, 42, 0.9);
          backdrop-filter: blur(8px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2000;
          padding: 20px;
          animation: fadeIn 0.3s ease;
        }

        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }

        .qr-modal-content {
          background: white;
          width: 100%;
          max-width: 500px;
          border-radius: 32px;
          position: relative;
          box-shadow: 0 40px 100px rgba(0,0,0,0.5);
          animation: modalScale 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        }

        @keyframes modalScale { from { transform: scale(0.85); opacity: 0; } to { transform: scale(1); opacity: 1; } }

        .modal-close {
          position: absolute;
          top: 20px;
          right: 25px;
          background: #f1f5f9;
          border: none;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          font-size: 2rem;
          color: #64748b;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          transition: 0.3s;
        }

        .modal-close:hover { background: #e2e8f0; color: #1e293b; }

        .modal-inner { padding: 50px 40px; text-align: center; }
        .modal-badge {
          background: rgba(59, 130, 246, 0.1);
          color: #3b82f6;
          padding: 6px 15px;
          border-radius: 30px;
          font-weight: 800;
          font-size: 0.8rem;
          text-transform: uppercase;
          letter-spacing: 1px;
          margin-bottom: 20px;
          display: inline-block;
        }

        .modal-inner h2 { font-size: 2rem; font-weight: 900; color: #1e293b; margin-bottom: 30px; line-height: 1.2; }
        .modal-inner h2 span { color: #3b82f6; display: block; }

        .large-qr-box {
          background: white;
          padding: 20px;
          border: 2px solid #f1f5f9;
          border-radius: 20px;
          display: inline-block;
          margin-bottom: 30px;
          animation: qrRotate 0.8s ease-out;
        }

        @keyframes qrRotate { from { transform: rotate(-5deg) scale(0.9); } to { transform: rotate(0) scale(1); } }
        .large-qr-box img { width: 250px; height: 250px; }

        .modal-info { color: #64748b; font-size: 1rem; line-height: 1.5; margin-bottom: 35px; }

        .modal-btn-close {
          background: #1e293b;
          color: white;
          border: none;
          padding: 15px 40px;
          border-radius: 12px;
          font-weight: 700;
          cursor: pointer;
          transition: 0.3s;
        }

        .modal-btn-close:hover { background: #0f172a; transform: translateY(-3px); }

        @media (max-width: 1024px) {
          .slide-title { font-size: 4rem; }
          .slide-subtitle { font-size: 1.5rem; }
          .qr-floating-support { bottom: 100px; right: 20px; }
        }

        @media (max-width: 768px) {
          .slide-title { font-size: 3rem; letter-spacing: -1px; }
          .slide-subtitle { font-size: 1.2rem; }
          .cta-btn { padding: 15px 35px; font-size: 1.1rem; }
          .slider-arrow { width: 50px; height: 50px; font-size: 2rem; }
          .slider-arrow.prev { left: 20px; }
          .slider-arrow.next { right: 20px; }
          .slider-dots { bottom: 30px; }
          .qr-floating-support { display: none; }
        }

        @media (max-width: 480px) {
          .slide-title { font-size: 2.2rem; }
          .slide-subtitle { font-size: 1rem; margin-bottom: 30px; }
          .cta-btn { padding: 12px 28px; font-size: 1rem; }
          .slider-arrow { display: none; }
        }
      `}</style>
    </header>
  );
};

export default Header;